import { getStorage, ref, uploadBytes, deleteObject, getDownloadURL, getBlob } from 'firebase/storage';
import { useFirebase } from './useFirebase';

/*
 * Warning: Calls to the Firebase Storage must be done from the Pathfinder project.
 * Mysterious issues occur when attempting to do so from the client or common projects.
 * e.g. exceptions in objectUrl() when attempting to access storage.
 *
 */

export function useFirebaseStorage() {
    const { firebaseApp } = useFirebase();

    let storage;

    const storageRef = (path) => {
        if (!storage) {
            storage = getStorage(firebaseApp);
        }
        return ref(storage, path);
    };

    const uploadStorageObject = async (path, file, metadata) => {
        return await uploadBytes(storageRef(path), file, metadata);
    };

    const deleteStorageObject = async (path) => {
        return await deleteObject(storageRef(path));
    };

    const getStorageDownloadURL = async (path) => {
        return await getDownloadURL(storageRef(path));
    };

    const downloadStorageObject = async (path) => {
        return await getBlob(storageRef(path));
    };

    return {
        getStorageDownloadURL,
        deleteStorageObject,
        uploadStorageObject,
        downloadStorageObject,
    };
}
